import React from 'react'
import CurrencyFormat from 'react-currency-format'
import style from './style.scss'

export default function Product({
  id,
  image,
  title,
  description,
  price,
  quantity,
  quantityBought,
  inCart,
  handleAddProduct,
  // giftsAvailable,
}) {


  // const handleClick = () => {
  //   // eslint-disable-next-line no-param-reassign
  //   if (giftsAvailable === 0) {
  //     // eslint-disable-next-line no-alert
  //     alert('A compra de presentes ainda não está aberta. Fale com quem o convidou ou entre em contato com nosso suporte.')
  //   }
  //   else {
  //     handleAddProduct(id)
  //   }

  // }

  return (
    <div className={style.product}>
      <img className={style.image} src={image} alt={title} />
      <h2 className={`${style.title} title-color`}>{title.substr(0, 30)}</h2>
      <p className={style.description}>{`${description.substr(0, 40)}`}</p>

      <CurrencyFormat
        value={price}
        displayType="text"
        thousandSeparator="."
        decimalSeparator=","
        isNumericString
        prefix="R$ "
        renderText={(value) => (
          <div className={`${style.price} title-color`}>{value}</div>
        )}
      />
      <p className={style.stock}>{`Restam: ${quantity - quantityBought
        } `}</p>
      <button
        type="button"
        className={`${style.btnAdd} title-button`}
        disabled={inCart || quantityBought === quantity}
        onClick={() => handleAddProduct(id)}
      >
        Adicionar
      </button>
      
    </div>
  )
}
